import React from 'react'
import { useIntl } from 'react-intl'
import Alert from '@berlitz/alert'
import { AddButton, BinButton } from './style'
import { StepWarningLabel } from '../style'
import Datepicker from '@components/Datepicker'
import Select from '@components/Select'
import { enGB } from 'date-fns/locale'
import Add from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/43-Remove-Add/Add'
import Bin1 from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/23-Delete/Bin1'
import { getMessages } from '../constants'
import { getDaysOptions, getTimeOptions } from './constants'
import Button from '@components/Button'
import { IDateInput, IDayInput, IFormButtons, ITimeInput } from './interface'
import moment from 'moment'
import { DATE_FORMAT } from '@utils/constants'
import useTimeFormat from '@hooks/useTimeFormat'

export const StepWarning = ({ classes = 3 }) => {
  const intl = useIntl()
  const messages = getMessages()
  return (
    <div className="warning">
      <Alert type="warning">
        <StepWarningLabel>
          {intl.formatMessage(messages.stepWarning, {
            classes,
          })}
        </StepWarningLabel>
      </Alert>
    </div>
  )
}

export const DateInput: React.FC<IDateInput> = ({ value, maxDate, onChange }) => {
  const intl = useIntl()
  const messages = getMessages()
  return (
    <Datepicker
      locale={enGB}
      value={value !== null ? moment(value).format(DATE_FORMAT.DD_MMMM_YYYY) : null}
      dateFormat="dd MMMM yyyy"
      style={{ width: 'max-content' }}
      placeholderText={intl.formatMessage(messages.formDatePlaceholder)}
      onSelect={onChange}
      isClearable={false}
      minDate={new Date()}
      maxDate={maxDate}
      openToDate={value !== null ? moment(value).toDate() : undefined}
    />
  )
}

export const DayInput: React.FC<IDayInput> = ({ index, value, onChange = () => {} }) => {
  const intl = useIntl()
  const messages = getMessages()
  const wrapperId = `day-input-${index}`
  return (
    <label
      id={wrapperId}
      style={{
        flexShrink: 1,
        width: '150px',
      }}
    >
      <Select
        onChange={onChange}
        options={getDaysOptions().map(({ label, ...rest }) => ({
          ...rest,
          label: intl.formatMessage({
            id: label,
            defaultMessage: label,
          }),
        }))}
        disableMargin
        responsive
        placeholderText={intl.formatMessage(messages.formDayPlaceholder)}
        fullWidth
        value={`${value ?? intl.formatMessage(messages.formDayPlaceholder)}`}
        getPopupContainer={() => document.getElementById(wrapperId)}
      />
    </label>
  )
}

export const TimeInput: React.FC<ITimeInput> = ({ index, value, onChange = () => {} }) => {
  const { convertToUserTimeFormats } = useTimeFormat()
  const intl = useIntl()
  const messages = getMessages()
  const wrapperId = `time-input-${index}`
  return (
    <div
      id={wrapperId}
      style={{
        flexShrink: 1,
        width: '120px',
      }}
    >
      <Select
        onChange={onChange}
        options={getTimeOptions().map(({ label, ...rest }) => ({
          ...rest,
          label: convertToUserTimeFormats(label, DATE_FORMAT.HMa),
        }))}
        disableMargin
        responsive
        placeholderText={intl.formatMessage(messages.formTimePlaceholder)}
        fullWidth
        value={value ?? intl.formatMessage(messages.formTimePlaceholder)}
        getPopupContainer={() => document.getElementById(wrapperId)}
      />
    </div>
  )
}

export const AddDay: React.FC<IFormButtons> = ({ onClick = () => {}, disabled }) => (
  <AddButton onClick={onClick} disabled={disabled}>
    <Add color="white" />
  </AddButton>
)

export const DeleteDay: React.FC<IFormButtons> = ({ onClick = () => {} }) => (
  <BinButton outline onClick={onClick}>
    <Bin1 />
  </BinButton>
)

export const FindButton: React.FC<IFormButtons> = ({ onClick = () => {}, disabled }) => {
  const intl = useIntl()
  const messages = getMessages()
  return (
    <Button onClick={onClick} disabled={disabled}>
      {intl.formatMessage(messages.formSearchButton)}
    </Button>
  )
}
